import React, { useState } from "react";
import Col from "react-bootstrap/Col";
import { Image } from "react-bootstrap";

import "./JoinCommunityPage.scss";
import PrimaryActionButton from "../../../components/Buttons/PrimaryActionButton/PrimaryActionButton";
import ImageConvo from "../../../images/join-community-convo.png";
import BackButton from "../../../components/Buttons/BackButton/BackButton";
import ImageTelegram from "../../../images/telegram-white-bg.svg";
import { LINKS, OnboardingSteps } from "../../../utils/constants";
import GhostButton from "../../../components/dashboard-page/GhostButton/GhostButton";
import { copyToClipboard } from "../../../utils/helpers";
import useOnboardingSteps from "../../../hooks/useOnboardingSteps";

function JoinCommunityPage() {
  const [hasJoined, setHasJoined] = useState(false);
  const message = "Hey, I'm new to Hyper. Challenge me: hyper-app.mvm.gg/KlgT";
  const { goToStep } = useOnboardingSteps();

  return (
    <div className="MobileOnly position-relative JoinCommunityPage px-3 pb-5">
      <Col>
        <BackButton onClick={() => goToStep(OnboardingSteps.FIND_FRIENDS)} />
        <h1>Your friends are in our community</h1>
      </Col>
      <Col className="img-box">
        <Image src={ImageConvo} width="100%" alt="conversation" />
      </Col>
      <div className="share-container d-flex align-items-center">
        <div>
          <p className="game-link-text">Step 1</p>
          <h3>Copy Message</h3>
          <p className="hey-text mt-0 mb-0">{message}</p>
        </div>
        <GhostButton
          className="copy-btn"
          onClick={() => copyToClipboard(message)}
        >
          Copy
        </GhostButton>
      </div>
      <div className="share-container">
        <p className="game-link-text">Step 2</p>
        <h3>Find Friends</h3>
        <p className="hey-text mt-0 mb-2">
          Paste copied message in Hyper community
        </p>
      </div>
      <div className="px-0 my-3">
        <PrimaryActionButton
          as="a"
          href={LINKS.SOCIAL.TELEGRAM}
          target="_blank"
          rel="noreferrer"
          text="Share in Hyper community"
          textClassName="share-btn-text"
          leftImage={ImageTelegram}
          style={{
            background: "linear-gradient(180deg, #37BBFE 0%, #007DBB 100%)",
            height: 40,
            borderRadius: 12,
            paddingTop: 8,
          }}
          onClick={() => setHasJoined(true)}
        />
      </div>
      <footer>
        <div className="mt-0 px-0">
          <PrimaryActionButton
            text="Continue"
            textClassName="continue-btn-text"
            disabled={!hasJoined}
            onClick={() => goToStep(OnboardingSteps.GET_APP)}
          />
          <p className="come-back-text mb-0">
            Come back and click “continue” to claim <span>100%</span> bonus.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default JoinCommunityPage;
